import { colors } from '@globals/themes/defaultTheme'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

const ClearAction = styled(Button)({
  variant: 'text',
  marginTop: '0 !important',
  color: colors.bluePrimary,
})

export default ClearAction
